import type { FieldValues, UseFormSetError } from 'react-hook-form';
import { extractValidationErrors } from '../../../Utils/apiErrorUtils';

const normalizeApiFieldPath = (fieldPath: string): string => {
  return fieldPath
    .replace(/^\$?\./, '')
    .split('.')
    .map((segment) => {
      if (!segment) {
        return segment;
      }

      return segment.charAt(0).toLowerCase() + segment.slice(1);
    })
    .join('.');
};

export const applyApiValidationErrorsToForm = <TFieldValues extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<TFieldValues>
): string[] => {
  const validationErrors = extractValidationErrors(error);
  if (!validationErrors) {
    return [];
  }

  const mappedFields: string[] = [];

  Object.entries(validationErrors).forEach(([fieldName, fieldErrors]) => {
    const firstMessage = Array.isArray(fieldErrors) ? fieldErrors[0] : undefined;
    if (!firstMessage) {
      return;
    }

    const normalizedFieldName = normalizeApiFieldPath(fieldName);
    mappedFields.push(normalizedFieldName);

    setError(normalizedFieldName as any, {
      type: 'server',
      message: firstMessage,
    });
  });

  return mappedFields;
};
